import {
  getCustomerOrderLineCancelQty,
  getCustomerOrderLineOrderQty,
  getMaterialSnapshotQtyPerProduct,
} from '#/modules/crmMgmt/customerOrder/helper/mapCustomerOrderMeta';

function toFiniteNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

/**
 * 客訂明細有效訂購量 = orderQty − cancelQty（下限 0）。
 * 讀 `qtySummary` 優先，fallback 扁平欄。
 */
export function resolveCustomerOrderLineEffectiveOrderQty(line) {
  const orderQty = toFiniteNumber(getCustomerOrderLineOrderQty(line));
  const cancelQty = toFiniteNumber(getCustomerOrderLineCancelQty(line));
  return Math.max(0, orderQty - cancelQty);
}

/**
 * 物料快照需求量 = 有效訂購量 × 單位用量。
 * 單位用量讀 `qtySummary.qtyPerProduct` 優先，fallback 扁平。
 */
export function resolveMaterialSnapshotRequiredQty(line, material) {
  const effectiveOrderQty = resolveCustomerOrderLineEffectiveOrderQty(line);
  const qtyPerProduct = toFiniteNumber(getMaterialSnapshotQtyPerProduct(material));

  if (qtyPerProduct <= 0 || effectiveOrderQty <= 0) {
    return null;
  }

  const requiredQty = effectiveOrderQty * qtyPerProduct;
  if (!Number.isFinite(requiredQty) || requiredQty <= 0) {
    return null;
  }

  return requiredQty;
}

/**
 * deep link query 用量字串；無效時回傳 null（省略 param）。
 */
export function formatMaterialSnapshotRequiredQtyForQuery(requiredQty) {
  if (requiredQty == null || !Number.isFinite(requiredQty) || requiredQty <= 0) {
    return null;
  }

  return String(requiredQty);
}
